import {React, useState, useEffect} from 'react';
import { Flex } from 'antd';
import ReactMarkDown from 'react-markdown';
import {LoadingOutlined} from '@ant-design/icons';
const KinShortDescription = (props) => {
    const [shortDescription, setShortDescription] = useState([]);
    useEffect(() => {
        setShortDescription([]);
        const fetchDescs = async (url) => {
            await fetch(url)
                .then(responce => responce.json())
                .then(responce => setShortDescription(responce));
        }
        fetchDescs("/data/kin_short_description_"+props.lang+".json");
    },[props.lang]);
    if(shortDescription.length > 0) {
        return (<ReactMarkDown>{shortDescription[props.kin]}</ReactMarkDown>)
    } else {
        return (<Flex align="center" justify="center" style={{width: "100%", height:"100%"}}>
        <LoadingOutlined/></Flex>)
    }
}
export default KinShortDescription;